export default {
    '保存成功':'Saved Successfully',
    '总日程表':'Master Schedule',
    '日程明细表':'Schedule Details',
    '单项日程明细表':'Individual Event Schedule',
    '报名列表':'Registration List',
    '第':'Round',
    '组':'Group',
    '编排成功':'Scheduled Successfully',
    '分组成功':'Grouping Completed',
    '取消编排':'Cancel Scheduling',
    '取消编排成功':'Scheduling Cancelled',
    '配置成功':'Configuration Successful',
    '编排列表':'Schedule List',
    '运动会积分列表':'Sports Meet Points List',
    '运动会明细列表':'Event Details List',
    '记录管理列表':'Record Management List',
    '记录导入模板':'Record Import Template',
    '结束成功':'Terminated Successfully',
    '日程表':'Schedule',
    '生成时间':'Generation Time',
    '重新生成日程表':'Regenerate Schedule',
    '总日程表导出':'Export Master Schedule',
    '日程明细导出':'Export Schedule Details',
    '导出':'Export',
    '序号已重复':'Duplicate Serial Number',
    '分组单位':'Grouping Unit',
    '赛次':'Event Round',
    '组数':'Number of Groups',
    '人数':'Participants',
    '地点':'Venue',
    '时间':'Time',
    '重新生成日程表后原数据将清空':'Regenerating the schedule will clear existing data',
    '序号不能重复，请检查':'Serial numbers must be unique. Please verify',
    '运动员列表':'Athlete List',
    '请选择分组单位':'Select Grouping Unit',
    '组别':'Category',
    '请选择组别':'Select Category',
    '分组状态':'Grouping Status',
    '请选择分组状态':'Select Grouping Status',
    '已分组':'Grouped',
    '未分组':'Ungrouped',
    '请输入运动员姓名或学籍号搜索':'Search by athlete name or student ID',
    '清空编排':'Clear Schedule',
    '自动分组':'Auto Grouping',
    '取消分组':'Cancel Grouping',
    '晋级方式':'Qualification Method',
    '跑道编号':'Lane Number',
    '运动员背心编码':'Athlete Vest Code',
    '跑道编号':'Lane Number',
    '请选择跑道编号':'Select Lane Number',
    '请选择编码':'Select Code',
    '每组人数':'Athletes per Group',
    '请输入每组人数':'Enter athletes per group',
    '每组队伍数':'Teams per Group',
    '请输入每组队伍数':'Enter teams per group',
    '是否跨班级':'Cross-class Grouping',
    '是否跨年级':'Cross-grade Grouping',
    '区分男女生':'Separate by Gender',
    '跨分组单位组号重置':'Reset Group Numbers Across Units',
    '最后两组数量均分':'Evenly Distribute Last Two Groups',
    '均分':'Even Distribution',
    '不均分':'Uneven Distribution',
    '生成分组':'Generate Groups',
    '修改学生编排信息':'Modify Student Schedule',
    '组内编号':'Internal Group ID',
    '请选择组内编号':'Select Internal Group ID',
    '仅查看未被占用的编号':'View Unassigned IDs Only',
    '若编号被占用，则编号互换':'Swap IDs if Occupied',
    '成员名单':'Member List',
    '批量导入将清空自动分组数据':'Bulk Import Overwrites Auto-grouping Data',
    '运动员姓名':'Athlete Name',
    '运动员编码':'Athlete Code',
    '成员':'Member',
    '设置编排条件':'Set Scheduling Conditions',
    '轮晋':'Round Advancement',
    '轮':'Round',
    '前':'Top',
    '名':'Place',
    '请输入':'Enter',
    '请选择编排方式':'Select Scheduling Method',
    '请选择运动员编码':'Select Athlete Code',
    '请选择序号':'Select Serial Number',
    '请填写每组人数':'Fill in Athletes per Group',
    '人数不能大于跑道编号！':'Athletes cannot exceed lane count!',
    '人数不能大于编码数量！':'Athletes cannot exceed code count!',
    '请选择跑道':'Select Lane',
    '注意：若修改上轮成绩或报名信息，将影响已有的编排，旧的编排数据将被覆盖':'Note: Modifying previous round scores or registrations will overwrite existing schedules[1](@ref)',
    '注意：分组条件发生了变化，将清空现有编排数据':'Note: Grouping criteria changes will clear current schedules',
    '继续将清除现有数据':'Proceeding will clear existing data',
    '确认要清空编排吗？':'Confirm to clear schedule?',
    '确认要取消分组吗？':'Confirm to cancel grouping?',
    '报名信息导入完成':'Registration Data Imported',
    '批量报名导入失败列表':'Failed Bulk Registration List',
    '编排信息导入完成':'Schedule Data Imported',
    '运动会编排模板':'Event Scheduling Template',
    '文件':'File',
    '批量成绩导入失败列表':'Failed Bulk Results List',
    '成绩导入完成':'Results Imported',
    '运动会成绩模板':'Event Results Template',
    '名次':'Ranking',
    '分值':'Points',
    '破纪录':'Record Broken',
    '若有多轮比赛，仅以决赛成绩为准':'Final round results determine rankings for multi-round events',
    '一':'1st',
    '二':'2nd',
    '三':'3rd',
    '四':'4th',
    '五':'5th',
    '六':'6th',
    '七':'7th',
    '八':'8th',
    '九':'9th',
    '十':'10th',
    '十一':'11th',
    '十二':'12th',
    '十三':'13th',
    '十四':'14th',
    '十五':'15th',
    '十六':'16th',
    '十七':'17th',
    '十八':'18th',
    '十九':'19th',
    '二十':'20th',
    '明细列表':'Details List',
    '轮次':'Round',
    '无效':'Invalid',
    '有效':'Valid',
    '违规':'Violation',
    '不违规':'No Violation',
    '是否有效':'Validity',
    '是否违规':'Violation Status',
    '班级名称模糊搜索':'Fuzzy Search by Class Name',
    '姓名，学籍号模糊搜索':'Search by Name/Student ID',
    '新增记录':'Add Record',
    '清空数据':'Clear Data',
    '团体赛':'Team Event',
    '个人赛':'Individual Event',
    '项目类型':'Event Type',
    '记录等级':'Record Level',
    '校级':'School Level',
    '年级':'Grade',
    '请选择年级':'Select Grade',
    '请选择年级班级':'Select Grade/Class',
    '男生':'Male',
    '女生':'Female',
    '记录':'Record',
    '创造者':'Creator',
    '所属单位':'Affiliation',
    '导入记录':'Import Record',
    '记录信息导入完成':'Record Data Imported',
    '项目不能为空':'Event is required',
    '记录等级不能为空':'Record level is required',
    '性别不能为空':'Gender is required',
    '记录不能为空':'Record is required',
    '记录填写错误':'Invalid record entry',
    '创造者不能为空':'Creator is required',
    '编辑记录':'Edit Record',
    '新增记录':'Add Record',
    '是否删除此条记录？':'Delete this record?',
    '是否清空记录？':'Clear all records?',
    '确认后，数据将不可恢复':'Data cannot be recovered once confirmed',
    '数据删除成功':'Data Deleted',
    '编辑记录成功':'Record Updated',
    '新增记录成功':'Record Created',
    '项目奖':'Event Award',
    '积分奖':'Points Award',
    '其他奖项':'Other Awards',
    '电子章管理':'E-Stamp Management',
    '打印':'Print',
    '注意：因模板格式问题，奖状内容部分仅支持1':'Note: Certificate content supports 1-3 lines due to template constraints. Check alignment before printing[1](@ref)',
    '注意：仅支持上传PNG格式的图片，比例为：1':'Note: Only 1:1 PNG images are supported',
    '电子章':'E-Stamp',
    '配置':'Configure',
    '奖状主体':'Certificate Subject',
    '获奖主体':'Awardee',
    '请输入获奖主体':'Enter awardee name',
    '运动会名称':'Event Name',
    '请输入运动会名称':'Enter event name',
    '比赛轮次':'Event Round',
    '请选择比赛轮次':'Select event round',
    '奖项名称':'Award Title',
    '请选择奖项名称':'Select award title',
    '获奖内容':'Award Details',
    '请输入获奖内容':'Enter award details',
    '请输入奖项名称':'Enter award title',
    '获奖名次':'Award Rank',
    '请选择获奖名次':'Select award rank',
    '颁奖机构':'Issuing Authority',
    '请输入颁奖机构':'Enter issuing authority',
    '颁奖日期':'Award Date',
    '请选择颁奖日期':'Select award date',
    '请选择电子章':'Select E-Stamp',
    '生成奖状':'Generate Certificate',
    '新增电子章':'Add E-Stamp',
    '名称':'Name',
    '请输入电子章名称':'Enter E-Stamp name',
    '点击上传图片':'Click to Upload Image',
    '支持上传比1':'Supports 1:1 PNG images under 2MB',
    '请选择项目名称':'Select event name',
    '请上传对应的电子章':'Upload corresponding E-Stamp',
    '请选择奖状主体':'Select certificate subject',
    '请输入颁奖日期':'Enter award date',
    '个人积分':'Individual Points',
    '班级积分':'Class Points',
    '请上传图片':'Upload Image',
    '电子章最多10个':'Max 10 E-Stamps allowed',
    '只能导入格式为png格式的文件！':'Only PNG files are supported',
    '图片已损坏':'Image Corrupted',
    '是否需要删除选中的电子章？':'Delete selected E-Stamps?',
    '请选择需要删除的电子章':'Select E-Stamps to delete',
    '积分列表':'Points List',
    '规则说明':'Rules',
    '积分规则配置':'Points Configuration',
    '生成积分':'Generate Points',
    '上次生成时间':'Last Generated',
    '修改':'Modify',
    '积分记录':'Points History',
    '1、成绩相同则名次相同，如：第1名和第2名成绩相同，将会产生两个第1名，后续名次为第3名。以此类推。':'1. Tied results share rankings (e.g., two 1st places if top two tie, followed by 3rd place)',
    '2、若同时有多个相同名次，则每位运动员获得的积分计算公式为：相同名次运动员所占用名次的积分之和':'2. Points for tied rankings = (Sum of tied rank points) / (Number of tied athletes)',
    '积分修改':'Adjust Points',
    '加减分数':'Add/Deduct Points',
    '积分':'Points',
    '积分来源':'Points Source',
    '确认要重新生成积分吗？':'Regenerate points? This clears existing data',
    '继续将清除现有积分数据':'Proceeding deletes current points',
    '积分修改成功':'Points Adjusted',
    '分数不能为空':'Points value required',
    '备注不能为空':'Remarks required',
    '加减分数最高只能为':'Max adjustment value:',
    '加减分数最低只能为':'Min adjustment value:',
    '详情':'Details',
    '报名':'Register',
    '编排':'Schedule',
    '记录管理':'Record Management',
    '明细':'Details',
    '证书':'Certificate',
    '项目列表':'Event List',
    '查看日程表':'View Schedule',
    '项目配置':'Event Setup',
    '赛制':'Event Format',
    '比赛方式':'Competition Method',
    '请选择该项目的比赛轮次，如预赛、决赛则选择2':'Select rounds (e.g., 2 for prelims + finals)',
    '最多四个字':'Max 4 characters',
    '排名赛':'Ranking Event',
    '团队赛':'Team Event',
    '田赛':'Field Event',
    '径赛':'Track Event',
    '组内':'Intra-group',
    '本轮参赛者':'Current Round Participants',
    '请选择赛制':'Select event format',
    '请选择比赛方式':'Select competition method',
    '该填写完整':'Complete all fields',
    '无编排数据！':'No schedule data',
    '附标题':'Subtitle',
    '请输入附标题':'Enter subtitle',
    '请上传比例为1':'Upload 1:1 PNG/JPG under 5MB',
    '报名时间':'Registration Period',
    '比赛时间':'Event Time',
    '赛事文件':'Event Documents',
    '正在上传':'Uploading',
    '上传文件':'Upload File',
    '未上传文件':'No File Uploaded',
    '50M以内；支持扩展名：':'Max 50MB (.xlsx/.docx/.pdf)',
    '每人限报数量':'Max entries per person',
    '修改后不影响已经报名的数据':'Changes do not affect existing registrations',
    '范围':'Scope',
    '班级报名人数':'Class Participants',
    '为空时，不限制人数':'Unlimited if empty',
    '队伍人数':'Team Size',
    '请输入标题':'Enter title',
    '请选择报名时间':'Select registration period',
    '请选择开始时间':'Select start time',
    '请选择结束时间':'Select end time',
    '请选择比赛时间':'Select event time',
    '比赛时间不得早于报名结束时间':'Event time must follow registration end',
    '请选择':'Select',
    '跑道':'Lane',
    '运动员成绩批量导出':'Bulk Export Results',
    '运动会列表':'Event List',
    '请输入运动会名称关键字':'Search event by name',
    '新增运动会':'Add Event',
    '运动风采':'Sports Gallery',
    '确认要删除该运动会：{name}':'Delete event {name}? This action is irreversible',
    '删除后将无法查看本运动会数据':'Deleted events cannot be restored',
    '确认要提前结束该运动会：':'Terminate event early?',
    '确认要提前结束该运动会：{name}':'End event {name} early?',
    '运动会结束后不再支持学生运动':'Post-event participation is disabled',
    '运动风采展示':'Sports Gallery',
    '全部选中':'Select All',
    '运动风采':'Sports Photos',
    '照片上传':'Photo Upload',
    '只能导入格式为png、jpg、jpeg格式的文件，单张照片大小不超过20M，历史导入最多不超过100张。':'Supports PNG/JPG/JPEG under 20MB (max 100 photos)',
    '上传成功数量：':'Success:',
    '上传失败数量：':'Failed:',
    '正在加载压缩文件':'Compressing Files',
    '风采':'Gallery',
    '正在压缩':'Compressing',
    '压缩完成':'Compression Complete',
    '文件压缩失败':'Compression Failed',
    '是否需要删除选中的图片？':'Delete selected photos?',
    '请选择需要删除的运动风采':'Select photos to delete',
    '导入失败，每个运动会最多支持100张图片！':'Max 100 photos per event',
    '部分导入成功':'Partial Success',
    '导入失败':'Import Failed',
    '导入成功':'Import Succeeded',
    '图片已损坏':'Image Corrupted',
    '编排方式':'Scheduling Method',
    '跑道数量':'Lane Count',
    '请选择跑道数量':'Select lane count',
    '编码':'Code',
    '重新分组将覆盖原有分组数据，是否重新分组？':'Regrouping overwrites existing data. Proceed?',
    '确认要取消编排吗？':'Confirm to cancel scheduling?',
    '姓名、学籍号、编号模糊搜索':'Search by Name/ID/Code',
    '运动会报名导入模板':'Event Registration Template',
    '运动员编号':'Athlete ID',
    '参赛项目':'Participating Event',
    '确认移除 {name}的报名信息吗':'Remove {name}\'s registration?',
    '该编号已经被使用':'Code already in use',
    '删除运动员':'Delete Athlete',
    '请选择运动员':'Select Athlete',
    '添加项目':'Add Event',
    '请选择运动会时间':'Select Event Date',
    '项目已有编排或报名数据，请清除相应数据后再移除。':'Clear existing data before removing an event',
    '请勿重复选择相同项目。':'Avoid duplicate event selection',
    '最佳成绩':'Best Score',

    // 2026.5.22
    '取消将清空表单内容':'Canceling will clear the form content',
    '基本信息':'Basic Information',
    '副标题':'Subtitle',
    '计分方式':'Scoring Method',
    '班级集体赛':'Class Group Competition',
    '班级团队赛':'Class Team Competition',
    '参赛班级':'Participating Class',
    '班级参赛人数':'Number of Participants in Class',
    '运动员已有成绩上报不可移除':'Athletes with submitted results cannot be removed',
    '是否移除该运动员':'Remove this athlete?',
    '移除后将同步清除该运动员编排信息其他编排数据不变':'Removal will clear the athletes arrangement information while other data remains unchanged',
    '新增报名':'New Registration',
    '输入完整学籍号搜索':'Search by complete student ID',
    '班级个人汇总':'Class Individual Summary',
    '班级个人最佳':'Class Personal Best',
    '班级个人平均':'Class Individual Average',
    '请选择计分方式':'Please select a scoring method',
    '运动强度':'Exercise Intensity',
    '选择项目':'Select Event',
    '运动方式':'Exercise Mode',
    '强度':'Intensity',
    '不限制':'No Restriction',
    '学籍号不能为空':'Student ID cannot be empty',
    '同班同组':'Same Class & Group',
    '已存在编排数据请清空后导入':'Arrangement data already exists. Please clear it before importing',
    '导出全量数据':'Export Full Data',
    '运动会明细总表':'Sports Meet Detailed General List',
    '作废':'Invalidate',
    '取消作废':'Undo Invalidation',
    '是否取消作废该记录':'Undo invalidation for this record?',
    '是否作废该记录':'Invalidate this record?',
    '取消后该成绩将置为有效':'The result will be restored to valid after undoing',
    '作废后成绩将置为无效':'The result will be marked invalid after invalidation',
    '是否取消':'Cancel?',
    '编号':'Serial Number',
    '未搜索到运动员':'No Athlete Found',

    // 2026.6.24 
    '编排条件设置':'Schedule Setup',
    '注意请确认当前编排的轮次是否正确':'Note: Confirm Round Correct?',
    '分组规模':'Group Size',
    '背心号码':'Vest Code',
    '道次':'Lane',
    '分组单位生成规则':'Grp Unit Gen Rule',
    '运动员仅在同一分组单位内排名不跨分组单位比较':'Rank Within Grp Unit Only',
    '分组规则':'Group Rule',
    '性别':'Gender',
    '区分男女':'Gender Split',
    '男女混合':'Mixed',
    '评比范围':'Eval Scope',
    '组号':'Group No.',
    '按分组单位重新编号':'Renumber By Grp Unit',
    '连续编号':'Consecutive No.',
    '末组均分':'Last Grp Even',
    '最后两组人数均分':'Even Last 2 Grps',
    '组内运动员分配':'Grp Athlete Assign',
    '班级内评比':'In-Class Eval',
    '年级内评比':'In-Grade Eval',
    '全校评比':'School Eval',
    '仅同班同组':'Same Class+Grp',
    '优先同班同组':'Priority Same Class+Grp',
    '仅同班不同组':'Same Class Diff Grp',
    '优先同班不同组':'Priority Same Class Diff Grp',
    '随机分配':'Random Assign',
    '成绩优异者居中':'Top In Middle',
    '道次分配':'Lane Assign',
    '背心号码分配':'Vest Code Assign',
    '序号分配':'Serial Assign'
  }